import React, { useEffect, useState } from 'react';
import { CheckIcon, StarIcon, ShieldCheckIcon, ZapIcon, ClockIcon, TrendingDownIcon, AlertTriangleIcon, ArrowDownIcon } from 'lucide-react';
import { PopupNotification } from '../components/PopupNotification';
const PURCHASE_URL = 'https://tucocinapractica.shop/cart/45277202022537:1';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/bemT1TWtQwy6AGAX6buKAV/Airfryer_sin_estres_Portada.png';
// Bonus images using the same product image as placeholder (square 1:1 ratio)
const bonusImages = [PRODUCT_IMAGE, PRODUCT_IMAGE, PRODUCT_IMAGE, PRODUCT_IMAGE];
function BuyButton({
  text,
  size = 'normal'
}: {
  text: string;
  size?: 'normal' | 'large';
}) {
  return <a href={PURCHASE_URL} target="_blank" rel="noopener noreferrer" className={`btn-pulse inline-block text-center font-black uppercase tracking-wide text-white rounded-full shadow-2xl transition-all duration-200 hover:brightness-110 active:scale-95 ${size === 'large' ? 'text-xl md:text-2xl px-10 py-6 w-full max-w-xl' : 'text-base md:text-lg px-8 py-5 w-full max-w-md'}`} style={{
    background: 'linear-gradient(135deg, #e63946 0%, #c1121f 100%)',
    fontFamily: 'Montserrat, sans-serif',
    textShadow: '0 1px 2px rgba(0,0,0,0.3)'
  }} data-id="element-14">
      🔥 {text}
    </a>;
}
function SectionDivider() {
  return <div className="flex items-center justify-center my-2" data-id="element-15">
      <div className="h-px bg-gray-200 flex-1" data-id="element-16" />
      <div className="mx-4 text-gray-300 text-lg" data-id="element-17">✦</div>
      <div className="h-px bg-gray-200 flex-1" data-id="element-18" />
    </div>;
}
export function LandingPage() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 47,
    seconds: 33
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        seconds--;
        if (seconds < 0) {
          seconds = 59;
          minutes--;
        }
        if (minutes < 0) {
          minutes = 59;
          hours--;
        }
        if (hours < 0) {
          hours = 2;
          minutes = 47;
          seconds = 33;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => String(n).padStart(2, '0');
  return <div className="w-full bg-white" style={{
    fontFamily: 'Inter, sans-serif'
  }} data-id="element-19">
      <PopupNotification data-id="element-20" />

      {/* TOP BAR - Urgency */}
      <div className="w-full py-3 px-4 text-center text-white text-sm font-bold" style={{
      background: 'linear-gradient(90deg, #1d1d1d, #333)'
    }} data-id="element-21">
        ⚡ OFERTA ESPECIAL — Termina en:{' '}
        <span className="inline-flex gap-1 ml-2" data-id="element-22">
          <span className="bg-red-600 text-white px-2 py-0.5 rounded font-mono text-sm" data-id="element-23">
            {pad(timeLeft.hours)}
          </span>
          <span className="text-white" data-id="element-24">:</span>
          <span className="bg-red-600 text-white px-2 py-0.5 rounded font-mono text-sm" data-id="element-25">
            {pad(timeLeft.minutes)}
          </span>
          <span className="text-white" data-id="element-26">:</span>
          <span className="bg-red-600 text-white px-2 py-0.5 rounded font-mono text-sm" data-id="element-27">
            {pad(timeLeft.seconds)}
          </span>
        </span>
      </div>

      {/* HERO SECTION */}
      <section className="w-full bg-white pt-12 pb-10 px-4" data-id="element-28">
        <div className="max-w-3xl mx-auto text-center" data-id="element-29">
          {/* Main Headline */}
          <h1 className="text-4xl md:text-6xl font-black text-gray-900 leading-tight mb-6" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-30">
            Dejá de improvisar qué cocinar{' '}
            <span style={{
            color: '#e63946'
          }} data-id="element-31">
              todas las noches
            </span>
          </h1>

          {/* Product Image — clickable */}
          <a href={PURCHASE_URL} target="_blank" rel="noopener noreferrer" className="block mx-auto mb-8 float-animation" style={{
          maxWidth: '380px'
        }} data-id="element-32">
            <img src={PRODUCT_IMAGE} alt="Airfryer sin Estrés — Sistema completo" className="w-full rounded-2xl shadow-2xl cursor-pointer hover:scale-105 transition-transform duration-300" style={{
            aspectRatio: '3/4',
            objectFit: 'cover'
          }} data-id="element-33" />
          </a>

          {/* Sub-headline */}
          <h2 className="text-2xl md:text-3xl font-black text-gray-900 leading-snug mb-4" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-34">
            Organizá 7 días de comidas en{' '}
            <span className="highlight-yellow" data-id="element-35">10 minutos</span> y cociná en
            menos de <span className="highlight-yellow" data-id="element-36">20</span> usando tu
            Airfryer
          </h2>
          <p className="text-lg text-gray-700 mb-6" data-id="element-37">
            — incluso si llegás agotado/a del trabajo.
          </p>
          <p className="text-xl font-bold text-gray-900 mb-8" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-38">
            El sistema completo con 11 recursos diseñados para eliminar el caos
            en tu cocina.
          </p>

          {/* Price + CTA */}
          <div className="bg-gray-50 border-2 border-red-200 rounded-2xl p-6 mb-6 inline-block w-full max-w-md mx-auto" data-id="element-39">
            <p className="text-gray-500 text-base mb-1" data-id="element-40">
              Antes <span className="strikethrough font-bold" data-id="element-41">$29.999</span>
            </p>
            <p className="text-5xl font-black text-gray-900 mb-1" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-42">
              $17.999
            </p>
            <p className="text-green-600 font-bold text-sm mb-4" data-id="element-43">
              ✅ Acceso inmediato. Descarga digital.
            </p>
            <div className="flex justify-center" data-id="element-44">
              <BuyButton text="QUIERO EL SISTEMA COMPLETO AHORA" data-id="element-45" />
            </div>
          </div>

          <p className="text-xs text-gray-400 mt-2" data-id="element-46">
            🔒 Pago 100% seguro · Garantía de 7 días · Acceso inmediato
          </p>
        </div>
      </section>

      {/* IDENTIFICATION SECTION */}
      <section className="w-full py-16 px-4" style={{
      background: '#1a1a1a'
    }} data-id="element-47">
        <div className="max-w-2xl mx-auto text-center" data-id="element-48">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-6" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-49">
            Compraste la Airfryer para simplificar.
          </h2>
          <p className="text-xl text-white/90 mb-8" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-50">
            Pero hoy:
          </p>

          <div className="text-left space-y-4 mb-6" data-id="element-51">
            {['Repetís siempre las mismas comidas', 'Abrís la heladera sin saber qué cocinar', 'Pedís delivery porque no tenés energía mental', 'Gastás más de lo que querés', 'Te prometés organizarte "la próxima semana"'].map((pain, i) => <div key={i} className="flex items-start gap-3 bg-white/5 rounded-xl p-4" data-id="element-52">
                <span className="text-red-400 text-xl flex-shrink-0" data-id="element-53">✗</span>
                <p className="text-white text-base font-medium" data-id="element-54">{pain}</p>
              </div>)}
          </div>

          <p className="text-white/80 text-lg mb-10" data-id="element-55">
            Y semana tras semana, el patrón se repite.
          </p>

          <div className="bg-red-900/40 border border-red-500/40 rounded-2xl p-6 text-left" data-id="element-56">
            <div className="flex items-start gap-3 mb-3" data-id="element-57">
              <AlertTriangleIcon className="w-6 h-6 text-yellow-400 flex-shrink-0 mt-0.5" data-id="element-58" />
              <h3 className="text-yellow-400 font-black text-lg" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-59">
                No es falta de disciplina.
              </h3>
            </div>
            <p className="text-white/90 text-base leading-relaxed mb-3" data-id="element-60">
              Es <strong className="text-yellow-400" data-id="element-61">fatiga de decisión</strong>
              .
            </p>
            <p className="text-white/80 text-base leading-relaxed mb-3" data-id="element-62">
              Después de 8 o 10 horas de trabajo, tu cerebro ya tomó demasiadas
              decisiones.
            </p>
            <p className="text-white/80 text-base leading-relaxed" data-id="element-63">
              Cuando no hay estructura, gana lo fácil.
            </p>
          </div>
        </div>
      </section>

      {/* BELIEF BREAK SECTION */}
      <section className="w-full py-14 px-4 bg-white" data-id="element-64">
        <div className="max-w-2xl mx-auto text-center" data-id="element-65">
          <h2 className="text-2xl md:text-3xl font-black text-gray-900 mb-4" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-66">
            El problema no es la receta.
          </h2>
          <p className="text-lg text-gray-700 mb-8" data-id="element-67">
            Si probaste recetas sueltas y nada cambió, no es porque no
            funcionen.
            <br data-id="element-68" />
            <strong data-id="element-69">Es porque falta sistema.</strong>
          </p>

          <div className="bg-gray-50 rounded-2xl p-6 mb-8 text-left" data-id="element-70">
            <h3 className="font-black text-gray-900 text-lg mb-4 text-center" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-71">
              Sin sistema:
            </h3>
            <div className="space-y-3" data-id="element-72">
              {['Improvisás.', 'Improvisar genera estrés.', 'El estrés genera gasto innecesario.', 'Y el ciclo se repite cada semana.'].map((text, i) => <div key={i} className="flex items-center gap-3" data-id="element-73">
                  <span className="w-7 h-7 rounded-full bg-red-100 text-red-600 font-black text-sm flex items-center justify-center flex-shrink-0" data-id="element-74">
                    {i + 1}
                  </span>
                  <p className="text-gray-700 text-base" data-id="element-75">{text}</p>
                </div>)}
            </div>
          </div>

          <div className="flex justify-center" data-id="element-76">
            <BuyButton text="QUIERO EL SISTEMA COMPLETO AHORA" data-id="element-77" />
          </div>
        </div>
      </section>

      {/* METHOD PRESENTATION SECTION */}
      <section className="w-full py-16 px-4" style={{
      background: 'linear-gradient(135deg, #e63946 0%, #c1121f 100%)'
    }} data-id="element-78">
        <div className="max-w-2xl mx-auto text-center" data-id="element-79">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-80">
            El Método 10–20
          </h2>
          <div className="flex flex-col md:flex-row gap-4 justify-center mb-8" data-id="element-81">
            <div className="bg-white/20 backdrop-blur rounded-2xl p-5 flex-1" data-id="element-82">
              <ClockIcon className="w-8 h-8 text-yellow-300 mx-auto mb-2" data-id="element-83" />
              <p className="text-white font-black text-2xl" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-84">
                10 min
              </p>
              <p className="text-red-100 text-sm" data-id="element-85">el domingo para decidir</p>
            </div>
            <div className="bg-white/20 backdrop-blur rounded-2xl p-5 flex-1" data-id="element-86">
              <ZapIcon className="w-8 h-8 text-yellow-300 mx-auto mb-2" data-id="element-87" />
              <p className="text-white font-black text-2xl" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-88">
                20 min
              </p>
              <p className="text-red-100 text-sm" data-id="element-89">diarios para ejecutar</p>
            </div>
            <div className="bg-white/20 backdrop-blur rounded-2xl p-5 flex-1" data-id="element-90">
              <CheckIcon className="w-8 h-8 text-yellow-300 mx-auto mb-2" data-id="element-91" />
              <p className="text-white font-black text-2xl" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-92">
                7 días
              </p>
              <p className="text-red-100 text-sm" data-id="element-93">completamente resueltos</p>
            </div>
          </div>
          <div className="bg-white/10 rounded-2xl p-6" data-id="element-94">
            <p className="text-white font-black text-xl mb-2" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-95">
              Un solo momento de claridad.
            </p>
            <p className="text-white/90 text-lg" data-id="element-96">
              Toda la semana en piloto automático.
            </p>
          </div>
        </div>
      </section>

      {/* STACK TRANSITION */}
      <section className="w-full py-12 px-4 bg-white" data-id="element-97">
        <div className="max-w-2xl mx-auto text-center" data-id="element-98">
          <p className="text-red-600 font-bold uppercase tracking-widest text-sm mb-3" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-99">
            No es un recetario
          </p>
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-3" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-100">
            Es un sistema completo diseñado para que tu cocina funcione con
            estructura
          </h2>
        </div>
      </section>

      {/* WHAT'S INCLUDED */}
      <section className="w-full py-16 px-4 bg-white" data-id="element-101">
        <div className="max-w-2xl mx-auto" data-id="element-102">
          <div className="text-center mb-10" data-id="element-103">
            <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-8" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-104">
              TODO LO QUE RECIBÍS HOY
            </h2>

            {/* Large Product Mockup */}
            <a href={PURCHASE_URL} target="_blank" rel="noopener noreferrer" className="block mx-auto mb-10" style={{
            maxWidth: '500px'
          }} data-id="element-105">
              <img src={PRODUCT_IMAGE} alt="Sistema completo Airfryer sin Estrés" className="w-full rounded-2xl shadow-2xl cursor-pointer hover:scale-105 transition-transform duration-300" style={{
              aspectRatio: '3/4',
              objectFit: 'cover'
            }} data-id="element-106" />
            </a>

            <p className="text-xl font-bold text-gray-900 mb-6" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-107">
              Incluye:
            </p>
          </div>

          <div className="space-y-3 mb-10" data-id="element-108">
            {['Airfryer sin Estrés — Núcleo mental y estratégico', 'Sistema Express 10–20 + 5 plantillas críticas', 'Planificador Inteligente editable', 'Batch Cooking estratégico (regla 3x3)', '50 Combinaciones listas en menos de 20 minutos', 'Recetario Maestro con 70 recetas prácticas', '10 Salsas y Dips rápidos', 'Guía de Errores Comunes', 'Guía de Tiempos y Temperaturas exactos', 'Menú semanal + lista optimizada', 'Tabla imprimible para la cocina'].map((item, i) => <div key={i} className="flex items-start gap-3 bg-gray-50 rounded-xl p-4" data-id="element-109">
                <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-110" />
                <p className="text-gray-800 text-base font-medium" data-id="element-111">{item}</p>
              </div>)}
          </div>

          <div className="text-center mb-6" data-id="element-112">
            <p className="text-gray-600 text-lg mb-2" data-id="element-113">
              Valor real por separado:{' '}
              <span className="strikethrough font-bold" data-id="element-114">más de $89.000</span>
            </p>
            <p className="text-gray-900 text-xl font-bold mb-4" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-115">
              Hoy accedés a todo por:
            </p>
            <p className="text-6xl font-black text-gray-900 mb-6" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-116">
              $17.999
            </p>
            <BuyButton text="QUIERO ACCESO INMEDIATO" data-id="element-117" />
          </div>
        </div>
      </section>

      {/* BONUSES SECTION */}
      <section className="w-full py-16 px-4" style={{
      background: '#1a1a1a'
    }} data-id="element-118">
        <div className="max-w-4xl mx-auto text-center" data-id="element-119">
          <p className="text-yellow-400 font-bold uppercase tracking-widest text-sm mb-3" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-120">
            🎁 BONOS ESPECIALES
          </p>
          <h2 className="text-3xl md:text-4xl font-black text-white mb-3" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-121">
            El sistema completo incluye       
          </h2>
          <p className="text-white/70 text-lg mb-2" data-id="element-122">
            Valor real por separado:{' '}
            <span className="strikethrough text-white/50" data-id="element-123">más de $89.000</span>
          </p>
          <div className="inline-block bg-yellow-400 text-gray-900 font-black text-lg px-6 py-2 rounded-full mb-10" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-124">
            ✨ GRATIS por el día de hoy
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-10" data-id="element-125">
            {/* Bonus 1 */}
            <div className="bg-white rounded-2xl overflow-hidden shadow-xl" data-id="element-126">
              <div style={{
              aspectRatio: '1/1'
            }} data-id="element-127">
                <img src="https://cdn.magicpatterns.com/uploads/5ezbNmpmFNderoGXJq31CH/Guia_rapida_de_tiempos_y_temperaturas_Portada.png" alt="Bono 1 — Guía rápida de tiempos y temperaturas" className="w-full h-full object-cover" data-id="element-128" />
              </div>
              <div className="p-3 text-left" data-id="element-129">
                <span className="text-xs font-bold text-red-600 uppercase tracking-wide" data-id="element-130">
                  Bono #1
                </span>
                <p className="font-black text-gray-900 text-sm mt-0.5" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-131">
                  Guía de Tiempos y Temperaturas
                </p>
                <p className="text-gray-500 text-xs" data-id="element-132">
                  Tabla imprimible para tu cocina
                </p>
                <p className="text-green-600 font-bold text-xs mt-1" data-id="element-133">
                  GRATIS hoy ✓
                </p>
              </div>
            </div>

            {/* Bonus 2 */}
            <div className="bg-white rounded-2xl overflow-hidden shadow-xl" data-id="element-134">
              <div style={{
              aspectRatio: '1/1'
            }} data-id="element-135">
                <img src="https://cdn.magicpatterns.com/uploads/cj2Aat6Z1GgCuoUNvyVGrS/Menu_semanal_y_compras_Portada.png" alt="Bono 2 — Menú semanal y lista de compras" className="w-full h-full object-cover" data-id="element-136" />
              </div>
              <div className="p-3 text-left" data-id="element-137">
                <span className="text-xs font-bold text-red-600 uppercase tracking-wide" data-id="element-138">
                  Bono #2
                </span>
                <p className="font-black text-gray-900 text-sm mt-0.5" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-139">
                  Menú Semanal + Lista de Compras
                </p>
                <p className="text-gray-500 text-xs" data-id="element-140">
                  Planificá tu semana en minutos
                </p>
                <p className="text-green-600 font-bold text-xs mt-1" data-id="element-141">
                  GRATIS hoy ✓
                </p>
              </div>
            </div>

            {/* Bonus 3 */}
            <div className="bg-white rounded-2xl overflow-hidden shadow-xl" data-id="element-142">
              <div style={{
              aspectRatio: '1/1'
            }} data-id="element-143">
                <img src="https://cdn.magicpatterns.com/uploads/2h2AGVctAL19oNWCKvFpRF/10_Salsas_y_dips_Portada.png" alt="Bono 3 — 10 Salsas y Dips" className="w-full h-full object-cover" data-id="element-144" />
              </div>
              <div className="p-3 text-left" data-id="element-145">
                <span className="text-xs font-bold text-red-600 uppercase tracking-wide" data-id="element-146">
                  Bono #3
                </span>
                <p className="font-black text-gray-900 text-sm mt-0.5" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-147">
                  10 Salsas y Dips Rápidos
                </p>
                <p className="text-gray-500 text-xs" data-id="element-148">
                  Para potenciar tus recetas
                </p>
                <p className="text-green-600 font-bold text-xs mt-1" data-id="element-149">
                  GRATIS hoy ✓
                </p>
              </div>
            </div>

            {/* Bonus 4 */}
            <div className="bg-white rounded-2xl overflow-hidden shadow-xl" data-id="element-150">
              <div style={{
              aspectRatio: '1/1'
            }} data-id="element-151">
                <img src="https://cdn.magicpatterns.com/uploads/1PATteURQEGE7sxp4zw8qK/70_Recetas_Portada.png" alt="Bono 4 — 70 Recetas Fáciles para Airfryer" className="w-full h-full object-cover" data-id="element-152" />
              </div>
              <div className="p-3 text-left" data-id="element-153">
                <span className="text-xs font-bold text-red-600 uppercase tracking-wide" data-id="element-154">
                  Bono #4
                </span>
                <p className="font-black text-gray-900 text-sm mt-0.5" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-155">
                  70 Recetas Fáciles para Airfryer
                </p>
                <p className="text-gray-500 text-xs" data-id="element-156">
                  Rápidas, prácticas y sin complicaciones
                </p>
                <p className="text-green-600 font-bold text-xs mt-1" data-id="element-157">
                  GRATIS hoy ✓
                </p>
              </div>
            </div>

            {/* Bonus 5 */}
            <div className="bg-white rounded-2xl overflow-hidden shadow-xl" data-id="element-158">
              <div style={{
              aspectRatio: '1/1'
            }} data-id="element-159">
                <img src="https://cdn.magicpatterns.com/uploads/81btFaUdM1axwyabJ5QVaR/Sistema_express_10-20_Portada.png" alt="Bono 5 — Sistema Express 10-20" className="w-full h-full object-cover" data-id="element-160" />
              </div>
              <div className="p-3 text-left" data-id="element-161">
                <span className="text-xs font-bold text-red-600 uppercase tracking-wide" data-id="element-162">
                  Bono #5
                </span>
                <p className="font-black text-gray-900 text-sm mt-0.5" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-163">
                  Sistema Express 10-20
                </p>
                <p className="text-gray-500 text-xs" data-id="element-164">
                  Planificación rápida para cocinar en menos tiempo
                </p>
                <p className="text-green-600 font-bold text-xs mt-1" data-id="element-165">
                  GRATIS hoy ✓
                </p>
              </div>
            </div>

            {/* Bonus 6 */}
            <div className="bg-white rounded-2xl overflow-hidden shadow-xl" data-id="element-166">
              <div style={{
              aspectRatio: '1/1'
            }} data-id="element-167">
                <img src="https://cdn.magicpatterns.com/uploads/pGTB4JyYDogmbXYxugC6UC/50_Combinaciones_inteligentes_Portada.png" alt="Bono 6 — 50 Combinaciones Inteligentes" className="w-full h-full object-cover" data-id="element-168" />
              </div>
              <div className="p-3 text-left" data-id="element-169">
                <span className="text-xs font-bold text-red-600 uppercase tracking-wide" data-id="element-170">
                  Bono #6
                </span>
                <p className="font-black text-gray-900 text-sm mt-0.5" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-171">
                  50 Combinaciones Inteligentes
                </p>
                <p className="text-gray-500 text-xs" data-id="element-172">
                  Listas en menos de 20 minutos
                </p>
                <p className="text-green-600 font-bold text-xs mt-1" data-id="element-173">
                  GRATIS hoy ✓
                </p>
              </div>
            </div>

            {/* Bonus 7 */}
            <div className="bg-white rounded-2xl overflow-hidden shadow-xl" data-id="element-174">
              <div style={{
              aspectRatio: '1/1'
            }} data-id="element-175">
                <img src="https://cdn.magicpatterns.com/uploads/jAHxuLxTLCc3v4YZnnzHRh/Tabla_Imprimible_Rapida_para_pegar_en_la_cocina_Portada.png" alt="Bono 7 — Tabla Imprimible para la Cocina" className="w-full h-full object-cover" data-id="element-176" />
              </div>
              <div className="p-3 text-left" data-id="element-177">
                <span className="text-xs font-bold text-red-600 uppercase tracking-wide" data-id="element-178">
                  Bono #7
                </span>
                <p className="font-black text-gray-900 text-sm mt-0.5" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-179">
                  Tabla Imprimible para la Cocina
                </p>
                <p className="text-gray-500 text-xs" data-id="element-180">
                  Pegala en tu heladera y listo
                </p>
                <p className="text-green-600 font-bold text-xs mt-1" data-id="element-181">
                  GRATIS hoy ✓
                </p>
              </div>
            </div>

            {/* Bonus 8 */}
            <div className="bg-white rounded-2xl overflow-hidden shadow-xl" data-id="element-182">
              <div style={{
              aspectRatio: '1/1'
            }} data-id="element-183">
                <img src="https://cdn.magicpatterns.com/uploads/dXDvZ3QGzFQVYVYa8pMfh9/Planificador_Semanal_Portada.png" alt="Bono 8 — Planificador Semanal Editable" className="w-full h-full object-cover" data-id="element-184" />
              </div>
              <div className="p-3 text-left" data-id="element-185">
                <span className="text-xs font-bold text-red-600 uppercase tracking-wide" data-id="element-186">
                  Bono #8
                </span>
                <p className="font-black text-gray-900 text-sm mt-0.5" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-187">
                  Planificador Semanal Editable
                </p>
                <p className="text-gray-500 text-xs" data-id="element-188">
                  Organizá tus comidas en minutos
                </p>
                <p className="text-green-600 font-bold text-xs mt-1" data-id="element-189">
                  GRATIS hoy ✓
                </p>
              </div>
            </div>

            {/* Bonus 9 */}
            <div className="bg-white rounded-2xl overflow-hidden shadow-xl" data-id="element-190">
              <div style={{
              aspectRatio: '1/1'
            }} data-id="element-191">
                <img src="https://cdn.magicpatterns.com/uploads/qEChkoJSCAXiBPAipB25SL/Errores_comunes_en_Airfryer_Portada.png" alt="Bono 9 — Errores Comunes en Airfryer" className="w-full h-full object-cover" data-id="element-192" />
              </div>
              <div className="p-3 text-left" data-id="element-193">
                <span className="text-xs font-bold text-red-600 uppercase tracking-wide" data-id="element-194">
                  Bono #9
                </span>
                <p className="font-black text-gray-900 text-sm mt-0.5" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-195">
                  Errores Comunes y Cómo Evitarlos
                </p>
                <p className="text-gray-500 text-xs" data-id="element-196">
                  Guía práctica para un mejor uso
                </p>
                <p className="text-green-600 font-bold text-xs mt-1" data-id="element-197">
                  GRATIS hoy ✓
                </p>
              </div>
            </div>

            {/* Bonus 10 */}
            <div className="bg-white rounded-2xl overflow-hidden shadow-xl" data-id="element-198">
              <div style={{
              aspectRatio: '1/1'
            }} data-id="element-199">
                <img src="https://cdn.magicpatterns.com/uploads/dBUK79e338457CXqLpodXU/Batch_Cooking_en_Airfryer_Portada.png" alt="Bono 10 — Batch Cooking en Airfryer" className="w-full h-full object-cover" data-id="element-200" />
              </div>
              <div className="p-3 text-left" data-id="element-201">
                <span className="text-xs font-bold text-red-600 uppercase tracking-wide" data-id="element-202">
                  Bono #10
                </span>
                <p className="font-black text-gray-900 text-sm mt-0.5" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-203">
                  Batch Cooking en Airfryer
                </p>
                <p className="text-gray-500 text-xs" data-id="element-204">
                  Cocina una vez, come toda la semana
                </p>
                <p className="text-green-600 font-bold text-xs mt-1" data-id="element-205">
                  GRATIS hoy ✓
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ECONOMIC BLOCK */}
      <section className="w-full py-14 px-4 bg-white" data-id="element-206">
        <div className="max-w-2xl mx-auto text-center" data-id="element-207">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-3" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-208">
            El caos no solo cuesta energía.
          </h2>
          <p className="text-2xl font-bold text-gray-900 mb-8" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-209">
            También cuesta dinero.
          </p>

          <p className="text-lg text-gray-700 mb-6" data-id="element-210">
            Si pedís delivery 3 veces por semana:
          </p>

          <div className="bg-red-50 border-2 border-red-200 rounded-2xl p-6 mb-6 text-left" data-id="element-211">
            <div className="space-y-3" data-id="element-212">
              <div className="flex justify-between items-center border-b border-red-100 pb-3" data-id="element-213">
                <span className="text-gray-700" data-id="element-214">
                  $8.000 promedio x 3 pedidos
                </span>
                <span className="font-black text-red-600 text-lg" data-id="element-215">
                  $24.000 / semana
                </span>
              </div>
              <div className="flex justify-between items-center border-b border-red-100 pb-3" data-id="element-216">
                <span className="text-gray-700" data-id="element-217">En un mes</span>
                <span className="font-black text-red-600 text-lg" data-id="element-218">
                  ≈ $100.000
                </span>
              </div>
              <div className="flex justify-between items-center pt-1" data-id="element-219">
                <span className="text-gray-900 font-bold" data-id="element-220">Este sistema</span>
                <span className="font-black text-green-600 text-xl" data-id="element-221">
                  $17.999
                </span>
              </div>
            </div>
          </div>

          <div className="bg-gray-900 rounded-2xl p-6 mb-8" data-id="element-222">
            <TrendingDownIcon className="w-10 h-10 text-green-400 mx-auto mb-3" data-id="element-223" />
            <p className="text-white font-black text-xl mb-2" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-224">
              Este sistema se paga solo evitando 2 pedidos.
            </p>
            <p className="text-green-400 font-bold" data-id="element-225">Después, todo es ahorro.</p>
          </div>

          <div className="flex justify-center" data-id="element-226">
            <BuyButton text="QUIERO ACCESO INMEDIATO" data-id="element-227" />
          </div>
        </div>
      </section>

      {/* RESULTS IN 2 WEEKS */}
      <section className="w-full py-16 px-4" style={{
      background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)'
    }} data-id="element-228">
        <div className="max-w-2xl mx-auto text-center" data-id="element-229">
          <p className="text-yellow-400 font-bold uppercase tracking-widest text-sm mb-3" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-230">
            Resultados en 2 semanas
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left mb-10" data-id="element-231">
            {['Reducís el delivery', 'Ahorrás 30–40% en comida', 'Cocinás sin pensar', 'Dejás de improvisar', 'Recuperás orden mental', 'Sentís control real'].map((result, i) => <div key={i} className="bg-white/10 rounded-xl p-4 flex items-start gap-3" data-id="element-232">
                <span className="w-6 h-6 rounded-full bg-green-500 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-233">
                  <CheckIcon className="w-4 h-4 text-white" data-id="element-234" />
                </span>
                <p className="text-white font-bold text-base" data-id="element-235">{result}</p>
              </div>)}
          </div>

          <div className="bg-yellow-400 rounded-2xl p-6" data-id="element-236">
            <p className="text-gray-900 font-black text-xl" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-237">
              No es solo comida.
            </p>
            <p className="text-gray-900 font-black text-2xl mt-1" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-238">
              Es claridad.
            </p>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="w-full py-16 px-4 bg-white" data-id="element-239">
        <div className="max-w-2xl mx-auto" data-id="element-240">
          <div className="text-center mb-10" data-id="element-241">
            <p className="text-red-600 font-bold uppercase tracking-widest text-sm mb-3" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-242">
              Lo que dicen quienes ya lo tienen
            </p>
            <h2 className="text-3xl md:text-4xl font-black text-gray-900" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-243">
              Resultados reales
            </h2>
          </div>

          <div className="space-y-5" data-id="element-244">
            {/* Testimonial 1 */}
            <div className="bg-gray-50 rounded-2xl p-6 border border-gray-100" data-id="element-245">
              <div className="flex items-center gap-1 mb-3" data-id="element-246">
                {[1, 2, 3, 4, 5].map(i => <StarIcon key={i} className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-247" />)}
              </div>
              <p className="text-gray-800 text-base leading-relaxed mb-4" data-id="element-248">
                "Llevaba meses con la Airfryer guardada porque no sabía qué
                hacer con ella. Con este sistema, en la primera semana ya
                organicé toda mi comida y dejé de pedir delivery.{' '}
                <strong data-id="element-249">Ahorré más de $30.000 en el primer mes.</strong> No lo
                puedo creer."
              </p>
              <div className="flex items-center gap-3" data-id="element-250">
                <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center font-black text-red-600" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-251">
                  V
                </div>
                <div data-id="element-252">
                  <p className="font-bold text-gray-900 text-sm" data-id="element-253">
                    Valentina C., 34 años
                  </p>
                  <p className="text-gray-500 text-xs" data-id="element-254">
                    Mamá de 2 hijos · Buenos Aires, Argentina
                  </p>
                </div>
              </div>
            </div>

            {/* Testimonial 2 */}
            <div className="bg-gray-50 rounded-2xl p-6 border border-gray-100" data-id="element-255">
              <div className="flex items-center gap-1 mb-3" data-id="element-256">
                {[1, 2, 3, 4, 5].map(i => <StarIcon key={i} className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-257" />)}
              </div>
              <p className="text-gray-800 text-base leading-relaxed mb-4" data-id="element-258">
                "Trabajo todo el día y cuando llegaba a casa lo último que
                quería era pensar en qué cocinar. Este sistema me cambió la
                vida.{' '}
                <strong data-id="element-259">
                  Ahora abro la heladera y ya sé exactamente qué hacer.
                </strong>{' '}
                En 20 minutos tengo la cena lista. Increíble."
              </p>
              <div className="flex items-center gap-3" data-id="element-260">
                <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center font-black text-blue-600" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-261">
                  M
                </div>
                <div data-id="element-262">
                  <p className="font-bold text-gray-900 text-sm" data-id="element-263">
                    Marcos T., 41 años
                  </p>
                  <p className="text-gray-500 text-xs" data-id="element-264">
                    Profesional independiente · Ciudad de México, México
                  </p>
                </div>
              </div>
            </div>

            {/* Testimonial 3 */}
            <div className="bg-gray-50 rounded-2xl p-6 border border-gray-100" data-id="element-265">
              <div className="flex items-center gap-1 mb-3" data-id="element-266">
                {[1, 2, 3, 4, 5].map(i => <StarIcon key={i} className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-267" />)}
              </div>
              <p className="text-gray-800 text-base leading-relaxed mb-4" data-id="element-268">
                "Siempre me prometía organizarme 'la próxima semana'. Con el
                Método 10–20 finalmente lo hice.{' '}
                <strong data-id="element-269">
                  El domingo planifico en 10 minutos y toda la semana está
                  resuelta.
                </strong>{' '}
                Mis hijos comen mejor y yo tengo más tiempo para mí."
              </p>
              <div className="flex items-center gap-3" data-id="element-270">
                <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center font-black text-purple-600" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-271">
                  C
                </div>
                <div data-id="element-272">
                  <p className="font-bold text-gray-900 text-sm" data-id="element-273">
                    Carolina M., 38 años
                  </p>
                  <p className="text-gray-500 text-xs" data-id="element-274">
                    Docente · Santiago, Chile
                  </p>
                </div>
              </div>
            </div>

            {/* Testimonial 4 */}
            <div className="bg-gray-50 rounded-2xl p-6 border border-gray-100" data-id="element-275">
              <div className="flex items-center gap-1 mb-3" data-id="element-276">
                {[1, 2, 3, 4, 5].map(i => <StarIcon key={i} className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-277" />)}
              </div>
              <p className="text-gray-800 text-base leading-relaxed mb-4" data-id="element-278">
                "Gastaba una fortuna en delivery. Desde que tengo el sistema,{' '}
                <strong data-id="element-279">reduje mis gastos en comida casi a la mitad</strong>.
                Las 50 combinaciones inteligentes son un golazo — nunca me quedo
                sin ideas y todo sale riquísimo en la Airfryer."
              </p>
              <div className="flex items-center gap-3" data-id="element-280">
                <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center font-black text-orange-600" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-281">
                  L
                </div>
                <div data-id="element-282">
                  <p className="font-bold text-gray-900 text-sm" data-id="element-283">
                    Luciana P., 29 años
                  </p>
                  <p className="text-gray-500 text-xs" data-id="element-284">
                    Estudiante de posgrado · Bogotá, Colombia
                  </p>
                </div>
              </div>
            </div>

            {/* Testimonial 5 */}
            <div className="bg-gray-50 rounded-2xl p-6 border border-gray-100" data-id="element-285">
              <div className="flex items-center gap-1 mb-3" data-id="element-286">
                {[1, 2, 3, 4, 5].map(i => <StarIcon key={i} className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-287" />)}
              </div>
              <p className="text-gray-800 text-base leading-relaxed mb-4" data-id="element-288">
                "Pensé que era otro recetario más. Pero no.{' '}
                <strong data-id="element-289">
                  Es un sistema completo que cambia cómo pensás la cocina.
                </strong>{' '}
                La guía de errores comunes me ahorró horas de frustraciones.
                Ahora cocino con confianza y mis comidas quedaron mil veces
                mejor."
              </p>
              <div className="flex items-center gap-3" data-id="element-290">
                <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center font-black text-green-600" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-291">
                  R
                </div>
                <div data-id="element-292">
                  <p className="font-bold text-gray-900 text-sm" data-id="element-293">
                    Roberto A., 45 años
                  </p>
                  <p className="text-gray-500 text-xs" data-id="element-294">
                    Contador · Montevideo, Uruguay
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* GUARANTEE */}
      <section className="w-full py-14 px-4" style={{
      background: '#f8f9fa'
    }} data-id="element-295">
        <div className="max-w-2xl mx-auto text-center" data-id="element-296">
          <div className="bg-white rounded-3xl p-8 shadow-xl border-2 border-green-200" data-id="element-297">
            <ShieldCheckIcon className="w-16 h-16 text-green-500 mx-auto mb-4" data-id="element-298" />
            <h2 className="text-2xl md:text-3xl font-black text-gray-900 mb-3" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-299">
              Probalo 7 días completos
            </h2>
            <p className="text-gray-700 text-lg leading-relaxed mb-4" data-id="element-300">
              Si no sentís que simplifica tu semana,{' '}
              <strong className="text-green-600" data-id="element-301">
                te devolvemos el dinero.
              </strong>
            </p>
            <p className="text-gray-500 text-base" data-id="element-302">Sin riesgos.</p>
          </div>
        </div>
      </section>

      {/* URGENCY + FINAL PRICE */}
      <section id="comprar" className="w-full py-16 px-4" style={{
      background: '#1a1a1a'
    }} data-id="element-303">
        <div className="max-w-2xl mx-auto text-center" data-id="element-304">
          <div className="bg-red-900/30 border border-red-500/40 rounded-2xl p-4 mb-8 inline-block" data-id="element-305">
            <p className="text-red-300 font-bold text-sm uppercase tracking-wide" data-id="element-306">
              ⏰ Precio promocional por tiempo limitado
            </p>
            <p className="text-white/80 text-sm mt-1" data-id="element-307">
              El precio de $17.999 es por tiempo limitado. Cuando esta etapa
              cierre, vuelve a su valor original.
            </p>
          </div>

          <h2 className="text-3xl md:text-4xl font-black text-white mb-4" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-308">
            No se trata de cocinar más.
          </h2>
          <p className="text-white/90 text-lg mb-2" data-id="element-309">
            Se trata de{' '}
            <strong className="text-yellow-400" data-id="element-310">decidir menos</strong>.
          </p>
          <p className="text-white/90 text-lg mb-2" data-id="element-311">
            Se trata de dejar de vivir en modo improvisación.
          </p>
          <p className="text-white/90 text-lg mb-8" data-id="element-312">
            Se trata de abrir la heladera y saber exactamente qué hacer.
          </p>

          {/* Final Price Box */}
          <div className="bg-white rounded-3xl p-8 mb-6 shadow-2xl" data-id="element-313">
            <p className="text-6xl font-black text-gray-900 mb-4" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-314">
              $17.999
            </p>
            <p className="text-gray-600 text-sm font-semibold mb-6" data-id="element-315">
              ACCESO INMEDIATO
            </p>

            <div className="flex justify-center mb-4" data-id="element-316">
              <BuyButton text="QUIERO DEJAR DE IMPROVISAR HOY" size="large" data-id="element-317" />
            </div>

            <p className="text-gray-400 text-xs" data-id="element-318">
              Descarga digital automática.
            </p>
          </div>

          <div className="flex items-center justify-center gap-6 text-white/50 text-xs" data-id="element-319">
            <span data-id="element-320">✓ Descarga digital</span>
            <span data-id="element-321">✓ Acceso inmediato</span>
            <span data-id="element-322">✓ Sin suscripción</span>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="w-full py-8 px-4 bg-black text-center" data-id="element-323">
        <p className="text-gray-600 text-xs" data-id="element-324">
          © 2025 Airfryer sin Estrés · Todos los derechos reservados
        </p>
        <p className="text-gray-700 text-xs mt-2" data-id="element-325">
          Producto digital · Descarga inmediata tras la compra
        </p>
      </footer>
    </div>;
}